import { render, staticRenderFns } from "./Phenotype.vue?vue&type=template&id=950aeae6&scoped=true"
import script from "./Phenotype.vue?vue&type=script&lang=js"
export * from "./Phenotype.vue?vue&type=script&lang=js"
import style0 from "./Phenotype.vue?vue&type=style&index=0&id=950aeae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950aeae6",
  null
  
)

export default component.exports